<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="기본정보" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline>
                <!-- [S]결재관련 버튼 -->
                <!-- sysApprovalRequestId: 상세조회시 관련 결재요청일련번호 확인 -->
                <!-- popupParam.isApprContent: 결재요청/결재처리 팝업의 component에 해당 페이지 호출시 true -->
                <!-- approvalStatusCd: 결재요청건에 대한 상태코드 -->
                <!-- popupParam.approvalDocType: TODO(결재할문서에서 상세페이지호출시) -->
                <c-appr-btn
                  v-if="!isApprDisabled && isUser"
                  ref="appr-btn"
                  name="danger-journal-appr-btn"
                  :editable="editable"
                  :approvalInfo="approvalInfo"
                  @beforeApprAction="saveDataAppr"
                  @callbackApprAction="approvalCallback"
                  @requestAfterAction="getDetail"
                />
                <c-btn
                  v-show="
                    !disabled && editable && !isUser && isOld && !isApprDisabled
                  "
                  :url="requestUrl"
                  :isSubmit="isRequest"
                  :param="nearAccident"
                  mappingType="PUT"
                  label="승인요청"
                  icon="check"
                  @beforeAction="requestNearAccident"
                  @btnCallback="requestCallback"
                />
                <c-btn
                  v-if="
                    Boolean(nearAccident.iimNearAccidentId) &&
                    !isApprDisabled &&
                    !disabled &&
                    editable
                  "
                  label="삭제"
                  icon="delete_forever"
                  @btnClicked="remove"
                />
                <c-btn
                  v-show="!disabled && editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="nearAccident"
                  :mappingType="saveType"
                  label="저장"
                  icon="save"
                  @beforeAction="saveNearAccident"
                  @btnCallback="saveCallback"
                />
                <c-btn
                  v-show="disabled && editable && approvalFlag"
                  :url="requestUrl2"
                  :isSubmit="isRequest2"
                  :param="nearAccident"
                  mappingType="PUT"
                  label="승인요청 회수"
                  icon="check"
                  @beforeAction="requestNearAccident2"
                  @btnCallback="requestCallback"
                />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <c-text
                  required
                  :editable="editable"
                  :disabled="disabled"
                  name="iimNearAccidentName"
                  label="아차사고명"
                  v-model="nearAccident.iimNearAccidentName"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-text
                  :editable="editable"
                  :disabled="true"
                  name="iimNearAccidentNo"
                  label="아차사고번호"
                  v-model="nearAccident.iimNearAccidentNo"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-multi-select
                  required
                  codeGroupCd="IIM_NEAR_KIND_CD"
                  :editable="editable"
                  :disabled="disabled"
                  :isArray="false"
                  itemText="codeName"
                  itemValue="code"
                  name="iimNearKindCds"
                  label="아차사고종류"
                  v-model="nearAccident.iimNearKindCds"
                >
                </c-multi-select>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-datepicker
                  required
                  :editable="editable"
                  :disabled="disabled"
                  type="datetime"
                  :minuteStep="10"
                  label="발생일시"
                  name="occurrenceDt"
                  v-model="nearAccident.occurrenceDt"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-process
                  required
                  :editable="editable"
                  :disabled="disabled"
                  label="공정"
                  name="processCd"
                  v-model="nearAccident.processCd"
                >
                </c-process>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <c-text
                  :editable="editable"
                  :disabled="disabled"
                  name="occurenceLocation"
                  label="발생가능장소"
                  v-model="nearAccident.occurrenceLocation"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-select
                  :editable="editable"
                  :disabled="disabled"
                  type="edit"
                  codeGroupCd="IIM_GRADE_CD"
                  itemText="codeName"
                  itemValue="code"
                  name="iimGradeCd"
                  label="아차사고등급"
                  v-model="nearAccident.iimGradeCd"
                >
                </c-select>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-field
                  v-if="!isVendor"
                  :editable="editable"
                  :disabled="disabled"
                  :data="nearAccident"
                  deptValue="discovererDeptCd"
                  label="발견자"
                  type="dept_user"
                  name="discovererId"
                  v-model="nearAccident.discovererId"
                >
                </c-field>
                <c-vendor
                  v-else
                  :editable="editable"
                  :disabled="true"
                  label="발견업체"
                  name="discovererId"
                  v-model="nearAccident.discovererId"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-field
                  v-if="!isVendor"
                  required
                  :editable="editable"
                  :disabled="disabled"
                  :data="nearAccident"
                  deptValue="reportDeptCd"
                  type="dept_user"
                  label="보고자"
                  name="reportUserId"
                  v-model="nearAccident.reportUserId"
                >
                </c-field>
                <c-vendor
                  v-else
                  :editable="editable"
                  :disabled="true"
                  label="보고업체"
                  name="reportUserId"
                  v-model="nearAccident.reportUserId"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-datepicker
                  :editable="editable"
                  :disabled="disabled"
                  type="datetime"
                  label="보고일시"
                  :minuteStep="10"
                  name="reportDt"
                  v-model="nearAccident.reportDt"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-dept
                  :required="isUser"
                  :disabled="disabled"
                  :editable="editable"
                  type="edit"
                  label="개선부서"
                  name="reviewDeptCd"
                  v-model="nearAccident.reviewDeptCd"
                />
              </div>
              <div
                v-if="isVendor"
                class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2"
              >
                <c-field
                  required
                  :disabled="disabled"
                  :editable="editable"
                  :data="nearAccident"
                  deptValue="requestManagerDeptCd"
                  type="dept_user"
                  userType="user"
                  label="업체승인담당자"
                  name="requestManagerId"
                  v-model="nearAccident.requestManagerId"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-plant
                  required
                  :disabled="disabled"
                  :editable="editable"
                  type="edit"
                  name="plantCd"
                  v-model="nearAccident.plantCd"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-radio
                  :editable="editable"
                  :disabled="disabled"
                  codeGroupCd="WEATHER_CD"
                  type="edit"
                  itemText="codeName"
                  itemValue="code"
                  name="weatherCd"
                  label="날씨"
                  v-model="nearAccident.weatherCd"
                ></c-radio>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="" class="cardClassDetailForm">
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-textarea
                  :editable="editable"
                  :disabled="disabled"
                  :rows="2"
                  label="긴급조치사항"
                  name="emergencyMeasures"
                  v-model="nearAccident.emergencyMeasures"
                >
                </c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-textarea
                  :editable="editable"
                  :disabled="disabled"
                  :isCheck="true"
                  :rows="2"
                  label="아차사고사항개요"
                  name="overviewAccidentSituation"
                  v-model="nearAccident.overviewAccidentSituation"
                  @checkboxClick="checkboxClick"
                >
                </c-textarea>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="사고발생시 상태" class="cardClassDetailForm">
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
                <!-- 인지기능 -->
                <c-checkbox
                  :editable="editable"
                  :disabled="disabled"
                  codeGroupCd="IIM_NEARMISS_DISCERN"
                  :isArray="false"
                  itemText="codeName"
                  itemValue="code"
                  label="인지기능"
                  name="iimNearDiscernCds"
                  v-model="nearAccident.iimNearDiscernCds"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
                <!-- 사고기능 -->
                <c-checkbox
                  :editable="editable"
                  :disabled="disabled"
                  codeGroupCd="IIM_NEARMISS_FUNCTION"
                  :isArray="false"
                  itemText="codeName"
                  itemValue="code"
                  label="사고기능"
                  name="iimNearFunctionCds"
                  v-model="nearAccident.iimNearFunctionCds"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
                <!-- 감정 -->
                <c-checkbox
                  :editable="editable"
                  :disabled="disabled"
                  codeGroupCd="IIM_NEARMISS_FEEL"
                  :isArray="false"
                  itemText="codeName"
                  itemValue="code"
                  label="감정"
                  name="iimNearFeelCds"
                  v-model="nearAccident.iimNearFeelCds"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
                <!-- 설비요인 -->
                <c-checkbox
                  :editable="editable"
                  :disabled="disabled"
                  codeGroupCd="IIM_NEARMISS_EQUIP"
                  :isArray="false"
                  itemText="codeName"
                  itemValue="code"
                  label="설비요인"
                  name="iimNearEquipCds"
                  v-model="nearAccident.iimNearEquipCds"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
                <!-- 관리요인 -->
                <c-checkbox
                  :editable="editable"
                  :disabled="disabled"
                  codeGroupCd="IIM_NEARMISS_MANAGE"
                  itemText="codeName"
                  itemValue="code"
                  :isArray="false"
                  label="관리요인"
                  name="iimNearManageCds"
                  v-model="nearAccident.iimNearManageCds"
                />
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
          <c-card title="발생 가능형태">
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-select
                  :editable="editable"
                  :disabled="disabled"
                  :comboItems="occFirstItems"
                  type="edit"
                  itemText="codeName"
                  itemValue="code"
                  name="occurrenceModeLargeCd"
                  label="대분류"
                  v-model="nearAccident.occurrenceModeLargeCd"
                ></c-select>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-select
                  :editable="editable"
                  :disabled="disabled"
                  :comboItems="occSecItems"
                  type="edit"
                  itemText="codeName"
                  itemValue="code"
                  name="occurrenceModeSmallCd"
                  label="중분류"
                  v-model="nearAccident.occurrenceModeSmallCd"
                ></c-select>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
          <c-card title="위험성평가" class="cardClassDetailForm">
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <c-text
                  :editable="editable"
                  :disabled="disabled"
                  type="number"
                  name="frequencyRisk"
                  label="빈도"
                  v-model="nearAccident.frequencyRisk"
                  @dataChange="dataChange"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <c-text
                  :editable="editable"
                  :disabled="disabled"
                  type="number"
                  name="strengthRisk"
                  label="강도"
                  v-model="nearAccident.strengthRisk"
                  @dataChange="dataChange"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <c-text
                  :editable="editable"
                  :disabled="true"
                  type="number"
                  name="totalRisk"
                  label="위험도"
                  v-model="nearAccident.totalRisk"
                />
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="사고발생 가능 원인" class="cardClassDetailForm">
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-text
                  :editable="editable"
                  :disabled="disabled"
                  name="directCause"
                  label="직접원인"
                  v-model="nearAccident.directCause"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-text
                  :editable="editable"
                  :disabled="disabled"
                  name="indirectCause"
                  label="간접원인"
                  v-model="nearAccident.indirectCause"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-text
                  :editable="editable"
                  :disabled="disabled"
                  name="openning"
                  label="기인물"
                  v-model="nearAccident.openning"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-text
                  :editable="editable"
                  :disabled="disabled"
                  name="injurious"
                  label="가해물"
                  v-model="nearAccident.injurious"
                />
              </div>
            </template>
          </c-card>
        </div>
      </div>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import { uid } from "quasar";
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "nearRegisterInfo",
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        iimNearAccidentId: "",
      }),
    },
    nearAccident: {
      type: Object,
      default: () => ({
        iimNearAccidentId: "",
        plantCd: "",
        iimNearAccidentNo: "",
        iimNearAccidentName: "",
        iimStatusNearCd: "",
        reportDeptCd: "",
        reportUserId: "",
        reportDt: "",
        iimNearKindCds: "",
        iimGradeCd: null,
        discovererId: "",
        occurrenceDt: "",
        occurrenceLocation: "",
        reviewDeptCd: "",
        weatherCd: "WC000001",
        emergencyMeasures: "",
        overviewAccidentSituation: "",
        occurrenceModeLargeCd: null,
        occurrenceModeSmallCd: null,
        directCause: "",
        indirectCause: "",
        openning: "",
        injurious: "",
        iimNearDiscernCds: null,
        iimNearFunctionCds: null,
        iimNearFeelCds: null,
        iimNearEquipCds: null,
        iimNearManageCds: null,
        processCd: "",
        frequencyRisk: "",
        strengthRisk: "",
        totalRisk: "",
        ramRiskAssessmentPlanId: "",
        auditScore: null,
        auditOpinion: "",
        bounty: null,
        requestManagerId: "",
        requestFlag: "N",
        vendorFlag: "",
        approvalRequestStatusCd: "", // 결재관련 결재상태 요청승인
        sysApprovalRequestRequestId: "", // 결재관련 결재요청코드 요청승인
        approvalReviewStatusCd: "", // 결재관련 결재상태 검토승인
        sysApprovalReviewRequestId: "", // 결재관련 결재요청코드 검토승인
        approvalAuditStatusCd: "", // 결재관련 결재상태 심사승인
        sysApprovalAuditRequestId: "", // 결재관련 결재요청코드 심사승인
        preventions: [],
      }),
    },
    isApprDisabled: {
      type: Boolean,
      default: false,
    },
    attachInfo1: {
      type: Object,
      default: function () {
        return {
          isSubmit: "",
          taskClassCd: "NEAR_FIRST_PICTURE",
          taskKey: "",
        };
      },
    },
    attachInfo2: {
      type: Object,
      default: function () {
        return {
          isSubmit: "",
          taskClassCd: "NEAR_SECOND_PICTURE",
          taskKey: "",
        };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isOld: {
      type: Boolean,
      default: false,
    },
    isUser: {
      type: Boolean,
      default: false,
    },
    isVendor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      approvalFlag: false,
      occFirstItems: [],
      occSecItems: [],
      editable: true,
      saveType: "POST",
      isSave: false,
      isApproval: false,
      isRequest: false,
      isRequest2: false,
      saveUrl: "",
      requestUrl: "",
      requestUrl2: "",
      deleteUrl: "",
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "90%",
        top: "10px",
        param: {},
        closeCallback: null,
      },
    };
  },
  watch: {
    // 상세조회를 했을 때 대분류에 따른 중분류의 값을 가져오는 부분
    "nearAccident.occurrenceModeLargeCd"() {
      if (!this.nearAccident.occurrenceModeLargeCd) return;
      this.setSecondItems(this.nearAccident.occurrenceModeLargeCd);
    },
  },
  computed: {
    approvalInfo() {
      return {
        sysApprovalRequestId: this.nearAccident.sysApprovalRequestRequestId, // 결재요청번호
        /**
         * 결재상태코드
         * ASC0000001	결재중
         * ASC0000002	반려
         * ASC9999999	결재완료
         */
        approvalStatusCd: this.nearAccident.approvalRequestStatusCd,
        apprEditable: !this.disabled && this.isOld, // 결재버튼 활성화 기준
        param: this.nearAccident, // 결재 param
        approvalUrl: transactionConfig.sop.iim.accident.near.update.url, // 결재 url
        isApproval: this.isApproval, // 결재 submit
        approvalTypeCd: "APTC000016", // 결재유형코드
        approvalParamValue: {
          // 결재상세화면 파라미터
          iimNearAccidentId: this.popupParam.iimNearAccidentId,
          iimStatusNearCd: this.nearAccident.iimStatusNearCd,
          isApprDisabled: true,
        },
        approvalRequestName:
          "[아차사고 요청승인] " + this.nearAccident.iimNearAccidentName, // 결재요청명 (문서 title)
        approvalConnId: this.popupParam.iimNearAccidentId, // 결재연결용 업무일련번호 (문서 key)
      };
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.occurUrl = selectConfig.sop.iim.occurForm.list.url;
      this.saveUrl = transactionConfig.sop.iim.accident.near.insert.url;
      this.requestUrl = transactionConfig.sop.iim.accident.near.request.url;
      this.requestUrl2 =
        transactionConfig.sop.iim.accident.near.request.url + "/cancel";
      this.deleteUrl = transactionConfig.sop.iim.accident.near.delete.url;
      // this.completeUrl = transactionConfig.sop.iim.accident.near.complete.url;
      // code setting
      this.approvalFlag = this.nearAccident.approvalRequestStatusCd
        ? false
        : true;
      this.setFirstItems();
      // list setting
    },
    getDetail() {
      this.$emit("getDetail");
    },
    setFirstItems() {
      this.$http.url = this.occurUrl;
      this.$http.type = "GET";
      this.$http.param = {
        useFlag: "Y", //사용중인 것만 가져옴
        occurLevel: "1", //발생레벨(깊이)
      };
      this.$http.request((_result) => {
        this.$_.forEach(_result.data, (_item) => {
          this.occFirstItems.splice(0, 0, {
            code: _item.iimOccurMasterId, //목록을 가져오는 부분
            codeName: _item.occurName, //가져온 목록의 이름을 넣는 부분
          });
        });
      });
    },
    setSecondItems(iimOccurMasterId) {
      this.$http.url = this.occurUrl;
      this.$http.type = "GET";
      this.$http.param = {
        iimUpOccurMasterId: iimOccurMasterId,
        useFlag: "Y",
        occurLevel: "2",
      };
      this.$http.request((_result) => {
        this.occSecItems = [];
        this.$_.forEach(_result.data, (_item) => {
          this.occSecItems.splice(0, 0, {
            code: _item.iimOccurMasterId,
            codeName: _item.occurName,
          });
        });
      });
    },
    dataChange() {
      //유효성체크(숫자만 들어오게)
      if (
        this.nearAccident.frequencyRisk !== null &&
        this.nearAccident.frequencyRisk >= 0 &&
        this.nearAccident.strengthRisk !== null &&
        this.nearAccident.strengthRisk >= 0
      ) {
        this.nearAccident.totalRisk =
          this.nearAccident.frequencyRisk * this.nearAccident.strengthRisk;
      }
    },
    checkboxClick(checkValue) {
      if (checkValue === "O") {
        this.nearAccident.overviewAccidentSituation =
          "- " +
          "누가 : \n" + // 누가
          "- " +
          "누구에게 : \n" + // 누구에게
          "- " +
          "언제 : \n" + // 언제
          "- " +
          "어디서 : \n" + // 어디서
          "- " +
          "무엇을 : \n" + // 무엇을
          "- " +
          "어떻게 : \n" + // 어떻게
          "- " +
          "왜 : ";
      } else {
        this.nearAccident.overviewAccidentSituation = "";
      }
    },
    saveNearAccident() {
      if (this.popupParam.iimNearAccidentId) {
        this.saveUrl = transactionConfig.sop.iim.accident.near.update.url;
        this.saveType = "PUT";
      } else {
        this.saveUrl = transactionConfig.sop.iim.accident.near.insert.url;
        this.saveType = "POST";
      }
      this.$refs["editForm"].validate().then((_result) => {
        if (_result) {
          window.getApp.$emit("CONFIRM", {
            title: "확인",
            message: "저장하시겠습니까?",
            // TODO : 필요시 추가하세요.
            type: "info", // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.nearAccident.regUserId = this.$store.getters.user.userId;
              this.nearAccident.chgUserId = this.$store.getters.user.userId;

              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit("APP_VALID_ERROR");
        }
      });
    },
    saveCallback(result) {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      if (!this.popupParam.iimNearAccidentId) {
        this.popupParam.iimNearAccidentId = result.data;
        // 관련사진에 사진을 저장하는 부분(없으면 상세조회 때 사진을 가져올 수 없음)
        this.$set(this.attachInfo1, "taskKey", result.data);
        this.$set(this.attachInfo2, "taskKey", result.data);
        this.$set(this.attachInfo1, "isSubmit", uid());
        this.$set(this.attachInfo2, "isSubmit", uid());
      }
      this.$emit("getDetail");
    },
    /* eslint-disable no-unused-vars */
    saveDataAppr() {
      window.getApp.$emit("CONFIRM", {
        title: "LBLCONFIRM",
        message: "결재요청 하기 전 입력된 값을 저장합니다.\n진행하시겠습니까?",
        type: "info", // success / info / warning / error
        confirmCallback: () => {
          this.nearAccident.regUserId = this.$store.getters.user.userId;
          this.nearAccident.chgUserId = this.$store.getters.user.userId;
          this.isApproval = !this.isApproval;
        },
        cancelCallback: () => {},
      });
    },
    // [S] 결재관련
    approvalCallback() {
      // 결재관련 결재요청버튼 callback
      this.$refs["appr-btn"].apprRequestPop();
    },
    requestNearAccident() {
      this.$refs["editForm"].validate().then((_result) => {
        if (_result) {
          window.getApp.$emit("CONFIRM", {
            title: "확인",
            message: "승인요청하시겠습니까?",
            type: "info", // success / info / warning / error
            confirmCallback: () => {
              this.nearAccident.chgUserId = this.$store.getters.user.userId;
              this.isRequest = !this.isRequest;
            },
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit("APP_VALID_ERROR");
        }
      });
    },
    requestNearAccident2() {
      this.$refs["editForm"].validate().then((_result) => {
        if (_result) {
          window.getApp.$emit("CONFIRM", {
            title: "확인",
            message: "승인요청을 회수 하시겠습니까?",
            // TODO : 필요시 추가하세요.
            type: "info", // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.nearAccident.chgUserId = this.$store.getters.user.userId;

              this.isRequest2 = !this.isRequest2;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit("APP_VALID_ERROR");
        }
      });
    },
    requestCallback(result) {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      this.$emit("getDetail");
    },
    remove() {
      window.getApp.$emit("CONFIRM", {
        title: "확인",
        message: "삭제하시겠습니까?",
        // TODO : 필요시 추가하세요.
        type: "info", // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(
            this.deleteUrl,
            this.popupParam.iimNearAccidentId,
          );
          this.$http.type = "DELETE";
          this.$http.request((_result) => {
            window.getApp.$emit("APP_REQUEST_SUCCESS");
            this.$emit("closePopup");
          });
        },
        // 취소 callback 함수
        cancelCallback: () => {},
      });
    },
  },
};
</script>
